
export const environment = {
  url: "",
  urlPs: ""
};